<template>
  <div
    class="w-[344px] mx-auto sm:mx-0 p-6 rounded-[20px] border border-[#424242] relative"
    :style="{ background: visibleCards[0].background }"
  >
    <div class="flex justify-between mb-6">
      <div class="astrology-horoscope-card-title flex flex-col text-20 font-semibold text-white">
        {{ visibleCards[0].title }}
      </div>
      <OButton :href="visibleCards[0].url" pure class="py-2 px-4 rounded-full bg-white text-black text-md leading-24 u-center">
        Görüntüle
      </OButton>
    </div>

    <div class="flex items-center">
      <button
        v-if="false"
        class="
          w-10
          h-10
          rounded-full
          bg-white/10
          flex
          items-center
          justify-center
          text-white
          transition-colors
          duration-200
          hover:bg-white/20
          border-none
          cursor-pointer
        "
        @click="handlePrev"
      >
        <OIcon icon="left-white" class="w-4 h-4" />
      </button>
      <div class="w-[170px] h-[240px] mx-auto relative">
        <div
          v-for="(card, index) in visibleCards"
          :key="currentIndex + index"
          class="
            absolute
            top-0
            left-0
            transition-all
            duration-300
            ease-in-out
            origin-center
            shadow-[0_2px_8px_rgba(0,0,0,0.2)]
            backface-hidden
          "
          :class="{
            'exit-to-corner': isExiting && index === 0,
            'return-to-deck': isReturning && index === 0,
            'stacked-card': index > 0,
          }"
          :style="{
            zIndex: getZIndex(index),
            transform: getCardTransform(index),
          }"
        >
          <OImage :src="card.image" :alt="card.title" />
        </div>
      </div>
      <button
        v-if="false"
        class="
          w-10
          h-10
          rounded-full
          bg-white/10
          flex
          items-center
          justify-center
          text-white
          transition-colors
          duration-200
          hover:bg-white/20
          border-none
          cursor-pointer
        "
        @click="handleNext"
      >
        <OIcon icon="right-white" class="w-4 h-4" />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { tarotTypes } from '../utils/tarotUtils';
import { OButton, OIcon, OImage } from '~/modules/common/components/ui';

export default defineComponent({
  props: {},
  components: {
    OButton,
    OIcon,
    OImage,
  },
  setup() {
    const currentIndex = ref(0);
    const isExiting = ref(false);
    const isReturning = ref(false);

    const visibleCards = computed(() => {
      const cards = tarotTypes;
      const currentIdx = currentIndex.value % cards.length;
      const result = [];

      for (let i = 0; i < 3; i++) {
        const idx = (currentIdx + i) % cards.length;
        result.push(cards[idx]);
      }

      return result;
    });

    const handleNext = () => {
      if (isExiting.value || isReturning.value) return;
      isExiting.value = true;

      setTimeout(() => {
        isExiting.value = false;
        isReturning.value = true;

        setTimeout(() => {
          currentIndex.value = (currentIndex.value + 1) % tarotTypes.length;
          isReturning.value = false;
        }, 300);
      }, 300);
    };

    const handlePrev = () => {
      if (isExiting.value || isReturning.value) return;

      isExiting.value = true;

      setTimeout(() => {
        currentIndex.value = (currentIndex.value - 1 + tarotTypes.length) % tarotTypes.length;
        isExiting.value = false;
      }, 300);
    };

    const getCardTransform = (index) => {
      if (index === 0) return 'translate(0, 0)';
      return `translate(${index * 2}px, ${index * 4}px) rotate(${index * 2}deg)`;
    };

    const getZIndex = (index) => {
      if (isReturning.value && index === 0) return 0;
      return visibleCards.value.length - index;
    };

    return {
      visibleCards,
      currentIndex,
      isExiting,
      isReturning,
      handleNext,
      handlePrev,
      getCardTransform,
      getZIndex,
    };
  },
});
</script>

<style>
/* Only keeping the transform animations that can't be done with Tailwind */
.backface-hidden {
  backface-visibility: hidden;
}

.exit-to-corner {
  transform: translate(40%, -20%) rotate(30deg) !important;
  opacity: 1;
}

.return-to-deck {
  transform: translate(8px, 16px) rotate(4deg) !important;
  opacity: 0.8;
  z-index: 0 !important;
  transition: all 0.3s ease;
}

.stacked-card {
  transform: translate(4px, 8px) rotate(2deg);
}
</style>
